import { render, staticRenderFns } from "./UploadWorkerLogo.vue?vue&type=template&id=a48aa6b8&scoped=true&"
import script from "./UploadWorkerLogo.vue?vue&type=script&lang=js&"
export * from "./UploadWorkerLogo.vue?vue&type=script&lang=js&"
import style0 from "./UploadWorkerLogo.vue?vue&type=style&index=0&id=a48aa6b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48aa6b8",
  null
  
)

export default component.exports